import React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getAccount, updateAccount } from "../../lib/api";
import { useAuth } from "../../lib/AuthContext";

const ALL = [["pwhl", "PWHL", "#9D4CDD"], ["nhl", "NHL", "#8A94A6"], ["international", "WWHC", "#E11D48"], ["ncaa", "NCAA", "#2563EB"]];

// Followed leagues — which competitions this account follows (default: all of them).
export function FollowedLeagues({ value, onChange, testid = "followed-leagues" }) {
    const { isOwner } = useAuth();
    const qc = useQueryClient();
    const { data: account } = useQuery({ queryKey: ["account"], queryFn: getAccount, enabled: !onChange });
    const leagues = ALL.filter(([k]) => k !== "ncaa" || isOwner);
    const cur = value || account?.profile?.followed_leagues || leagues.map(([k]) => k);
    const toggle = async (k) => {
        const next = cur.includes(k) ? cur.filter((x) => x !== k) : [...cur, k];
        if (!next.length) return;
        if (onChange) { onChange(next); return; }
        await updateAccount({ followed_leagues: next });
        qc.invalidateQueries({ queryKey: ["account"] });
    };
    return (
        <div className="space-y-2" data-testid={testid}>
            <div className="text-[10px] font-black uppercase tracking-[0.18em] text-white/50">Followed Leagues</div>
            <div className="flex flex-wrap gap-1.5">
                {leagues.map(([k, l, c]) => {
                    const on = cur.includes(k);
                    return (
                        <button key={k} type="button" onClick={() => toggle(k)} data-testid={`${testid}-${k}`}
                            style={on ? { background: `${c}26`, borderColor: `${c}80`, color: "#fff" } : undefined}
                            className={`px-3 py-1.5 rounded-lg border text-[10px] font-black uppercase tracking-wider transition-colors ${on ? "" : "border-white/15 text-white/45 hover:text-white"}`}>{l}</button>
                    );
                })}
            </div>
        </div>
    );
}
